<template>
  <div class="container mx-auto p-8">
    <Head :title="`Orden #${order?.number_order}`" />
    <div class="flex items-center">
      <div class="relative mr-2 px-4 py-2 text-white bg-blue-800 rounded-l-lg">
        <span class="text-sm font-medium">1</span>
        <span class="ml-2 text-sm font-medium">Detalles de pedido</span>
      </div>
      <div class="relative px-4 py-2 text-gray-600 bg-gray-200 rounded-r-lg">
        <span class="text-sm font-medium">2</span>
        <span class="ml-2 text-sm font-medium">Procesar pago</span>
      </div>
    </div>

    <!-- <div class="flex justify-end mb-6">
      <button class="px-4 py-2 text-white text-sm font-bold bg-blue-800 hover:bg-sky-700 rounded">Imprimir reporte</button>
    </div> -->

    <div class="container mx-auto p-8 px-16 bg-white rounded">
      <div>
        <p class="text-sm font-bold">Estatus:</p>
        <span :class="stateColor">{{ translatedState }}</span>
        <p class="mt-2 text-sm font-bold">Modalidad:</p>
        <span class="ml-1">{{order?.isCredit ? 'Credito' : 'De contado'}}</span>
      </div>

      <div class="mt-4">
        <p class="text-sm font-bold">Información:</p>
        <p class="mt-1 text-gray-600 text-xs leading-relaxed"></p>
      </div>

      <div class="mt-6 overflow-x-auto">
        <table class="min-w-full divide-gray-200 divide-y">
          <thead class="bg-blue-800">
            <tr>
              <th scope="col" class="px-6 py-3 text-left text-white text-xs font-medium tracking-wider uppercase">Producto</th>
              <th scope="col" class="px-6 py-3 text-center text-left text-white text-xs font-medium tracking-wider uppercase">Unidades</th>
              <th scope="col" class="px-6 py-3 text-center text-left text-white text-xs font-medium tracking-wider uppercase">Precio</th>
              <th scope="col" class="px-6 py-3 text-left text-right text-white text-xs font-medium tracking-wider uppercase">Total</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-gray-200 divide-y">
            <tr v-for="(item, index) in order?.products" :key="index">
              <td class="px-6 py-4 whitespace-nowrap text-sm">{{ item?.product?.description }}</td>
              <td class="px-6 py-4 text-center whitespace-nowrap text-sm">{{ item?.quantity }}</td>
              <td class="px-6 py-4 text-center whitespace-nowrap text-sm">${{ (item?.price).toFixed(2) }}</td>
              <td class="px-6 py-4 text-right whitespace-nowrap text-sm">${{ item?.total }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="grid gap-4 grid-cols-2 mt-6">
        <div>
          <p class="text-sm font-bold">Subtotal:</p>
          <p class="mt-1 text-sm font-bold">Descuento:</p>
          <p class="mt-1 text-sm font-bold">Total:</p>
          <p class="mt-1 text-sm font-bold">Balance:</p>
        </div>
        <div class="text-right">
          <p class="text-sm">${{order.total}}</p>
          <p class="mt-1 text-sm">${{order.discount}}</p>
          <p class="mt-1 text-sm">${{order.total}}</p>
          <p class="mt-1 text-sm">${{order.balance}}</p>
        </div>
      </div>

      <div v-if="order?.order_state != 'finish' && order?.order_state != 'estimate'" class="flex justify-end mt-8">
        <a :href="`/web/payments/${order.id}`" class="px-4 py-2 text-white text-sm font-bold bg-blue-800 hover:bg-sky-700 rounded">Procesar pago</a>
      </div>
    </div>
  </div>
</template>

<script>
import WebLayout from '../../Layouts/WebLayout.vue'
import { Head } from '@inertiajs/inertia-vue3'
export default {
  components: {
    Head
  },
  layout: WebLayout,
  props: {
    order: Object
  },
  data() {
    return {
      items: [
        { producto: 'Timer 6 cables inclinados', unidades: 1, total: '$2.1' },
        { producto: 'Timer 3 cables', unidades: 1, total: '$2.4' },
        { producto: 'Timer 6 cables inclinados', unidades: 1, total: '$2.1' },
        { producto: 'Timer 6 cables inclinados', unidades: 1, total: '$2.1' },
      ],
    }
  },
  mounted() {
      console.log(this.order)
  },
  computed: {
    translatedState() {
      const states = {
        'estimate': 'Presupuesto',
        'pending': 'Pendiente',
        'processing': 'Procesando',
        'completed': 'Completado',
        'cancelled': 'Cancelado',
        'shipped': 'Enviado',
        'delivered': 'Entregado',
        'refunded': 'Reembolsado'
      }
      return states[this.order?.order_state] || this.order?.order_state || 'No disponible'
    },
    stateColor() {
      const colors = {
        'estimate': 'text-yellow-500',
        'pending': 'text-yellow-500',
        'processing': 'text-blue-500',
        'completed': 'text-green-500',
        'cancelled': 'text-red-500',
        'shipped': 'text-purple-500',
        'delivered': 'text-green-600',
        'refunded': 'text-gray-500'
      }
      return colors[this.order?.order_state] || 'text-gray-700'
    }
  }
}
</script>
